import ASRDisclaimer from './ASRDisclaimer';

export default ASRDisclaimer;
